import type {
  ActionItem,
  ApiBuildAgentConfig,
  MeetingAction
} from "../types/buildAgent";
import { ActionType } from "../types/buildAgent";

// Helper function to create new action
export function createNewAction(
  integration: string,
  actionName: string,
  actionId: string
): ActionItem {
  const integrationType = integration.toLowerCase();
  const actionType = integrationType || ActionType.calendly;

  return {
    id: actionId,
    type: actionType as ActionType,
    name: actionName,
    config: {},
    enabled: true
  };
}

// Helper function to check if action already exists
export function actionExists(
  currentActions: ActionItem[],
  newAction: ActionItem
): boolean {
  return currentActions.some(
    (action) => action.type === newAction.type && action.name === newAction.name
  );
}

// Helper function to create action config from meeting action
export function createActionConfigFromMeetingAction(
  meetingAction: MeetingAction
): Record<string, string> {
  return {
    message: meetingAction.message || "Click the button to connect with us👇",
    demoLink: meetingAction.cta_url || "https://example.com",
    action_id: meetingAction.action_id,
    ui_type: meetingAction.ui_type || "button",
    button_text: meetingAction.button_text || "Book Meeting"
  };
}

// Helper function to create mock action config with default values
export function createMockActionConfig(
  existingConfig?: Record<string, string>
): Record<string, string> {
  const defaultConfig = {
    message: "Let's schedule a meeting!",
    demoLink: "calendly.com/example/meeting",
    action_id: "829013a0-626e-4c53-8652-8fb3f3e41af1",
    ui_type: "button",
    button_text: "Book Meeting"
  };

  return { ...defaultConfig, ...existingConfig };
}

/**
 * Methods written to be compatible with new data structures.
 * @param config
 * @returns
 */
export function formatBuildAgentConfig(
  config: ApiBuildAgentConfig
): ApiBuildAgentConfig {
  const { onboarding_step, completed_onboarding_steps } = config;

  const currentLinearFinishedSteps = onboarding_step - 1;

  const newCompletedOnboardingSteps = new Set(completed_onboarding_steps);

  if (!completed_onboarding_steps?.length && currentLinearFinishedSteps) {
    for (let i = 1; i <= currentLinearFinishedSteps; i++) {
      newCompletedOnboardingSteps.add(i);
    }
  }

  return {
    ...config,
    completed_onboarding_steps: [...newCompletedOnboardingSteps]
  };
}
